/**
 * Renders an artifact page. The HTML arrives already wrapped by the API with
 * the viewer CSP (no network, no forms, no remote images, CDN allow-list).
 *
 * `sandbox="allow-scripts"` WITHOUT `allow-same-origin` gives the page an
 * opaque origin: it cannot read app cookies/storage, reach this DOM or call
 * our API. No popup / top-navigation flags, and no data is ever posted in.
 */
export default function ArtifactFrame({
  html,
  title,
}: {
  html: string
  title: string
}) {
  return (
    <iframe
      title={title}
      srcDoc={html}
      sandbox="allow-scripts"
      referrerPolicy="no-referrer"
      className="w-full h-full border-0 rounded-lg bg-white"
      data-testid="artifact-frame"
    />
  )
}
